import React, { Component } from 'react';

class NoMatch extends Component {
    render() {
        return (
          <div id="Services">
            <h5><i className="fas fa-map-signs"></i> Lost Traveler</h5>
            <p> Woah, you lost your way...</p>
           <p> </p>
            <p><a href="https://gnosisdevelopment.formstack.com/forms/bug_report">Report dead link?</a> </p>
        </div>
        );
    }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js